var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V16C22 17.1046 21.1046 18 20 18H12.75V20.5H15C15.4142 20.5 15.75 20.8358 15.75 21.25C15.75 21.6642 15.4142 22 15 22H9C8.58579 22 8.25 21.6642 8.25 21.25C8.25 20.8358 8.58579 20.5 9 20.5H11.25V18H4C2.89543 18 2 17.1046 2 16V5ZM11.5 6.9C11.5 5.57452 10.3807 4.5 9 4.5C7.61929 4.5 6.5 5.57452 6.5 6.9C6.5 8.22548 7.61929 9.3 9 9.3C10.3807 9.3 11.5 8.22548 11.5 6.9ZM4 11.7C4 14.351 6.23858 16.5 9 16.5C11.7614 16.5 14 14.351 14 11.7C14 11.0373 13.4404 10.5 12.75 10.5H5.25C4.55964 10.5 4 11.0373 4 11.7ZM15 5.25C14.5858 5.25 14.25 5.58579 14.25 6C14.25 6.41421 14.5858 6.75 15 6.75H19C19.4142 6.75 19.75 6.41421 19.75 6C19.75 5.58579 19.4142 5.25 19 5.25H15ZM14.25 9C14.25 9.41421 14.5858 9.75 15 9.75H17C17.4142 9.75 17.75 9.41421 17.75 9C17.75 8.58579 17.4142 8.25 17 8.25H15C14.5858 8.25 14.25 8.58579 14.25 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.5086ac70746bd4860f7e938ba4f1407d.svg";
export { ForwardRef as ReactComponent };